import React, { useEffect, useState, useRef } from 'react';
import { Back_top_icon } from '../commonComponents/svg';
import './backToTop.scss';

const BackToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [firstElementHeight, setFirstElementHeight] = useState(0);
  const backToTopBtnRef = useRef(null);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  };

  const setBackToTopPos = () => {
    const backToTopBtn = backToTopBtnRef.current;
    if (!backToTopBtn) return;

    let paddingSize = '1.5rem';

    if (window.innerWidth < 960) {
      backToTopBtn.style.bottom = paddingSize;
      backToTopBtn.style.transform = `translateX(calc(${window.innerWidth / 2}px - ${backToTopBtn.offsetWidth / 2}px - ${paddingSize}))`;
    } else if (window.innerWidth >= 960 && window.innerWidth <= 1440) {
      paddingSize = '3rem';
      backToTopBtn.style.bottom = paddingSize;
      backToTopBtn.style.transform = `translateX(calc(${window.innerWidth / 2}px - ${backToTopBtn.offsetWidth / 2}px - ${paddingSize}))`;
    } else {
      paddingSize = '3rem';
      backToTopBtn.style.bottom = paddingSize;
      backToTopBtn.style.transform = `translateX(calc(720px - ${backToTopBtn.offsetWidth / 2}px - ${paddingSize}))`;
    }
  };

  useEffect(() => {
    const firstElement = document.querySelector('main > section:first-child');
    if (firstElement) {
      setFirstElementHeight(firstElement.offsetHeight);
    }

    const showDelay = 1000;
    const hideDelay = 3000;

    let isScrolling;
    let hasScrolledPastFirstElement = false;

    const handleScroll = () => {
      window.clearTimeout(isScrolling);

      isScrolling = setTimeout(() => {
        if (hasScrolledPastFirstElement) {
          setIsVisible(false);
        }
      }, hideDelay);

      if (window.scrollY > firstElementHeight) {
        hasScrolledPastFirstElement = true;
        setTimeout(() => {
          if (hasScrolledPastFirstElement) {
            setIsVisible(true);
          }
        }, showDelay);
      } else {
        hasScrolledPastFirstElement = false;
        setIsVisible(false);
      }
    };

    const handleResize = () => {
      setBackToTopPos();
    };

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleResize);
    setBackToTopPos();  // Set initial position

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
    };
  }, [firstElementHeight]);

  return (
    <div
      ref={backToTopBtnRef}
      className={`btn back-to-top ${isVisible ? '' : 'hidden'}`}
      onClick={scrollToTop}
    >
      <div className="arrow btn-icon">
        <Back_top_icon/>
      </div>
    </div>
  );
};

export default BackToTopButton;